<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t('school.academic.operation.profile_mgt.studentProfile.pageTitle')
        }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t(
            'school.academic.operation.profile_mgt.studentProfile.pageTitle'
          ),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <div class="ts-flex">
            <ts-button color="info" outline @click="$router.push({ name: 'student-profile-create' })">{{ $t('add_new')
              }}</ts-button>
            <!-- <ts-button
              class="btn-sm ml-2"
              :disabled="!checkedStudent.length > 0"
              outline
              color="primary"
              @click.prevent="showStatusForm(checkedStudent)"
            >
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.changeStatue'
                )
              }}
            </ts-button> -->
            <div class="ml-2 ts-rounded ts-border ts-px-2 ts-whitespace-no-wrap mr-2">
              <div class="radio radio-css radio-inline">
                <input v-model="side" type="radio" id="front" :value="'front'" />
                <label for="front">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.front'
                    )
                  }}
                </label>
              </div>
              <div class="radio radio-css radio-inline">
                <input v-model="side" type="radio" id="back" :value="'back'" />
                <label for="back">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.back'
                    )
                  }}
                </label>
              </div>
              <!-- Old Preview Card  -->
              <ts-button v-if="true" class="btn-sm ml-2" :disabled="!checkedStudent.length > 0" outline color="primary"
                @click.prevent="
                  side == 'back' ? (visibleCard = true) : previewCard('simple')
                  ">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.previewCard'
                  )
                }}
              </ts-button>
            </div>
            <!-- New Preview Card -->
            <div class="ts-mr-2" v-if="false">
              <b-dropdown dropdown :text="$t(
                'school.academic.operation.profile_mgt.studentProfile.previewCard'
              )
                " variant="primary">
                <b-dropdown-item :disabled="!checkedStudent.length > 0" href="#" @click="previewCard('simple')">
                  <i class="fas fa-print"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.simplePrinter'
                    )
                  }}
                </b-dropdown-item>
                <b-dropdown-item :disabled="!checkedStudent.length > 0" href="#" @click="previewCard('pro')">
                  <i class="fas fa-id-card"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.proPrinter'
                    )
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <b-dropdown dropdown :text="$t(
              'school.academic.operation.profile_mgt.studentProfile.exportExcel'
            )
              " variant="outline-success" :waiting="exporting">
              <b-dropdown-item :disabled="!checkedStudent.length > 0" href="#" @click="exportExcelSelectedStudent">
                <i class="fas fa-check-square"></i>
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.selectedStudent'
                  )
                }}
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="exportExcelAllStudent">
                <i class="fas fa-users"></i>
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.allStudent'
                  )
                }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="ts-flex ts-justify-end">
            <label class="mt-2 mr-2 ml-2">Filter Status</label>
            <select class="form-control" style="width: 120px" v-model="status_id">
              <option value="All">
                {{ $t('studentprofile.all') }}
              </option>
              <option v-for="(s, index) in studentStatus" :key="index" :value="s.status_id">
                {{ s.status }}
              </option>
            </select>
            <div class="ml-2 mr-2">
              <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px" />
            </div>
            <b-dropdown dropdown variant="outline-default" :waiting="exporting" no-caret right>
              <template v-slot:button-content>
                <i class="fas fa-align-justify"></i>
              </template>
              <b-dropdown-item href="#" @click="showFilter">
                <i class="fas fa-filter"></i>
                {{ $t('studentprofile.filter') }}
              </b-dropdown-item>
              <b-dropdown-item @click="$router.push({ name: 'student-profile-card-by-class' })">
                <i class="fas fa-address-card"></i>
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.cardByClass'
                  )
                }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">

          <Table :columns="icolumns" :data="resources" :loading="loading" max-height="700" stripe highlight-row
            size="small" ref="selection" :row-selection="{
              checkedStudent: checkedStudent,
              onChange: handleSelectionChange
            }" @on-select="onSelectCheck" @on-select-cancel="onSelectUncheck" @on-select-all="onSelectAllCheck"
            @on-select-all-cancel="onSelectAllUncheck">
            <template slot-scope="{ row }" slot="branch">
              {{ row.branch ? row.branch.branch_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="photo">
              <img class="height-40 ts-rounded" :class="{ 'external-student': row.is_external }" v-lazy="{
                src: photoStudent(row),
                error: onError(row),
                loading: require('@/assets/Rolling-1s-200px_2.svg')
              }" />
            </template>
            <template slot-scope="{ row }" slot="status">
              <span class="badge badge-success" v-if="row.status.status == 'Active'">{{ $t('studentprofile.active')
              }}</span>
              <span class="badge badge-danger" v-if="row.status.status == 'Droped out'">{{
                $t('studentprofile.dropedOut') }}</span>
              <span class="badge badge-warning" v-if="row.status.status == 'Terminated'">{{
                $t('studentprofile.terminated') }}</span>
              <span class="badge badge-indigo" v-if="row.status.status == 'Suspend'">{{ $t('studentprofile.suspend')
              }}</span>
            </template>
            <template slot="sub_program" slot-scope="{ row }">
              <table class="table-status">
                <tr v-for="(item, index) in row.sub_programs" :key="index">
                  <td>{{ item.acps_name_foreign }}</td>
                  <td class="ts-whitespace-no-wrap">
                    <span class="text-success" v-if="item.pivot.status_id == 1">{{ $t('studentprofile.active')
                    }}</span>
                    <span class="text-danger" v-if="item.pivot.status_id == 2">{{ $t('studentprofile.dropedOut')
                    }}</span>
                    <span class="text-warning" v-if="item.pivot.status_id == 4">{{ $t('studentprofile.terminated')
                    }}</span>
                    <span class="text-indigo" v-if="item.pivot.status_id == 3">{{ $t('studentprofile.suspend')
                    }}</span>
                  </td>
                  <td>
                    <a href="#" class="text-primary icon"
                      @click.prevent="showStatusBySubProgramForm(item)">
                      <i class="fas fa-edit"></i>
                    </a>
                  </td>
                </tr>
              </table>
            </template>
            <template slot="classes" slot-scope="{ row }">
              <table class="table-status">
                <tr v-for="(item, index) in row.classes" :key="index">
                  <td>{{ item.class_name }}</td>
                </tr>
              </table>
            </template>
            <template slot="father" slot-scope="{row}">
              {{ row.parent ? row.parent.father_name_en : '' }}
            </template>
            <template slot="mother" slot-scope="{row}">
              {{ row.parent ? row.parent.mother_name_en : '' }}
            </template>
            <template slot="counter" slot-scope="{row}">
              <a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_increase')" :ok-text="$t('yes')"
                :cancel-text="$t('no')" @confirm="increaseCounter(row)">
                <a href="#" class="ts-border ts-rounded-full ts-px-2 ts-h-1 ts-bg-teal-500 ts-text-white">
                  <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                  <span v-else>
                    {{
                      row.card_print_counter
                        ? row.card_print_counter
                        : 0
                    }}
                  </span>
                </a>
              </a-popconfirm>
            </template>
            <template slot="action" slot-scope="{ row }">
              <a href="#" v-tooltip="$t('edit')" class="mr-2 text-primary" @click.prevent="edit(row)">
                <i class="fas fa-edit"></i>
              </a>
              <a href="#" v-tooltip="$t('studentprofile.insurance')" class="mr-2 text-primary"
                @click.prevent="insurance(row)">
                <i class="fas fa-hand-holding-heart"></i>
              </a>
              <a href="#" v-tooltip="$t('tooltip.status')" class="mr-2 text-warning" v-if="row.sub_programs.length == 0"
                @click.prevent="showStatusForm(row)">
                <i class="far fa-stop-circle"></i>
              </a>
              <a href="#" v-tooltip="$t(
                'school.academic.operation.profile_mgt.studentProfile.excel'
              )
                " class="mr-2 text-success" @click.prevent="excel(row)">
                <i class="fas fa-file-excel"></i>
              </a>
              <a href="#" v-tooltip="$t(
                'school.academic.operation.profile_mgt.studentProfile.audio'
              )
                " class="mr-2 text-success" :class="{
                  'text-pink': !row.audio_file_name
                }" @click.prevent="showAudioForm(row)">
                <i class="fas fa-volume-up" v-if="row.audio_file_name"></i>
                <i class="fas fa-volume-down" v-if="!row.audio_file_name"></i>
              </a>
              <a href="#" v-tooltip="$t(
                'school.academic.operation.profile_mgt.studentProfile.showDetail'
              )
                " class="text-info" @click.prevent="show(row)">
                <i class="fas fa-eye"></i>
              </a>
              <b-dropdown size="xs" variant="link" toggle-class="text-decoration-none" no-caret right v-tooltip="$t(
                'school.academic.operation.profile_mgt.studentProfile.card'
              )
                ">
                <template slot="button-content">
                  <i class="fas fa-id-card"></i>
                </template>
                <b-dropdown-item @click="card(row, 'front')">
                  <i class="fas fa-address-card"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.frontCard'
                    )
                  }}
                </b-dropdown-item>
                <b-dropdown-item @click="card(row, 'back')">
                  <i class="far fa-credit-card"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.backCard'
                    )
                  }}
                </b-dropdown-item>
              </b-dropdown>
              <a href="#" v-tooltip="$t('delete')" class="mr-2 text-danger" @click.prevent="showDeleteForm(row)"
                :disabled="row._deleting">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>

            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
      <a-drawer :title="$t('invoice.filter')" placement="right" :closable="false" :visible="visible"
        @close="() => (visible = false)" :zIndex="1020" width="300px">
        <ts-loading-banner :loading="waiting_fetch">
          <div style="font-size: 12px">
            <div class="row">
              <div class="form-group ts-w-full">
                <a-select style="width: 257px" v-model="branch_id" :options="branchs" showSearch mode="multiple"
                  :filterOption="(input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                    " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')" @change="fetchData()">
                </a-select>
              </div>
            </div>
            <div class="row">
              <label class="mt-2 ts-w-full">
                {{ $t('studentprofile.mainProgramStudy') }}
              </label>
              <div class="ts-w-full">
                <select class="form-control" style="width: 100%" v-model="main_program_count">
                  <option :value="null">
                    {{ $t('studentprofile.all') }}
                  </option>
                  <option value="one">
                    {{ $t('studentprofile.oneMainProgram') }}
                  </option>
                  <option value="two">
                    {{ $t('studentprofile.twoMainPrograms') }}
                  </option>
                  <option value="greater_than_two">
                    {{ $t('studentprofile.moreThanTwoMainPrograms') }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <label class="mt-2 ts-w-full">Sub Program</label>
              <div class="ts-w-full">
                <a-select
                  style="width: 100%"
                  v-model="acps_id"
                  :options="sub_programs"
                  mode="multiple"
                  showSearch
                  allowClear
                  :maxTagCount="1"
                  :maxTagTextLength="20"
                  :placeholder="$t('studentprofile.all')"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                >
                </a-select>
              </div>
            </div>
            <div class="row">
              <div class="form-group ts-w-full mt-2">
                <label>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.className'
                    )
                  }}
                </label>
                <ts-select-class v-model.number="class_id" />
              </div>
            </div>
            <div class="row">
              <legend class="text-black ts-text-sm">
                {{ $t('studentprofile.printCard') }}
              </legend>
              <div class="form-group">
                <div class="radio radio-css radio-inline is-valid">
                  <input v-model="is_print_card" type="radio" id="printedCard" :value="true" />
                  <label for="printedCard">
                    {{ $t('studentprofile.printedCard') }}
                  </label>
                </div>
                <div class="radio radio-css radio-inline is-invalid">
                  <input v-model="is_print_card" type="radio" id="no_print_card" :value="false" />
                  <label for="no_print_card">{{ $t('studentprofile.notYetPrintCard') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <legend class="text-black ts-text-sm">
                {{ $t('studentprofile.cardActivation') }}
              </legend>
              <div class="form-group">
                <div class="radio radio-css radio-inline is-valid">
                  <input v-model="id_card_activated" type="radio" id="activated" :value="'yes'" />
                  <label for="activated">
                    {{ $t('studentprofile.activated') }}
                  </label>
                </div>
                <div class="radio radio-css radio-inline is-invalid">
                  <input v-model="id_card_activated" type="radio" id="no_activated" :value="'no'" />
                  <label for="no_activated">{{ $t('studentprofile.notYetActivate') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <legend class="text-black ts-text-sm">
                {{ $t('studentprofile.photoUpload') }}
              </legend>
              <div class="form-group">
                <div class="radio radio-css radio-inline is-valid">
                  <input v-model="photo_exists" type="radio" id="uploaded" :value="'yes'" />
                  <label for="uploaded">{{ $t('studentprofile.uploaded') }}
                  </label>
                </div>
                <div class="radio radio-css radio-inline is-invalid">
                  <input v-model="photo_exists" type="radio" id="no_upload" :value="'no'" />
                  <label for="no_upload">{{ $t('studentprofile.notYetUpload') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <legend class="text-black ts-text-sm">
                {{ $t('studentprofile.soundUpload') }}
              </legend>
              <div class="form-group">
                <div class="radio radio-css radio-inline is-valid">
                  <input v-model="sound_exists" type="radio" id="sound_uploaded" :value="'yes'" />
                  <label for="sound_uploaded">{{ $t('studentprofile.uploaded') }}
                  </label>
                </div>
                <div class="radio radio-css radio-inline is-invalid">
                  <input v-model="sound_exists" type="radio" id="no_sound_upload" :value="'no'" />
                  <label for="no_sound_upload">
                    {{ $t('studentprofile.notYetUpload') }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <legend class="text-black ts-text-sm">
                {{ $t('studentprofile.linkedWithParent') }}
              </legend>
              <div class="form-group">
                <div class="radio radio-css radio-inline is-valid">
                  <input v-model="linked_with_parent" type="radio" id="linked" :value="'yes'" />
                  <label for="linked"> {{ $t('studentprofile.linked') }} </label>
                </div>
                <div class="radio radio-css radio-inline is-invalid">
                  <input v-model="linked_with_parent" type="radio" id="no_link" :value="'no'" />
                  <label for="no_link">
                    {{ $t('studentprofile.notYetLink') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <ts-button class="btn-block" @click.prevent="clearFilter">
                <i class="far fa-times-circle"></i>
                {{ $t('studentprofile.clearFilter') }}
              </ts-button>
            </div>
          </div>
        </ts-loading-banner>
      </a-drawer>
      <a-modal v-model="visibleCard" :width="300" @ok="previewCard('simple')">
        <div class="form-group m-b-15">
          <label>Print Date</label>
          <ts-date-picker-input v-model="print_date"> </ts-date-picker-input>
        </div>
      </a-modal>
      <a-modal v-model="showInsurance" v-if="showInsurance" :title="$t('studentprofile.insurance')" :footer="null"
        width="700px">
        <Insurance :studentInsurance="studentInsurance" @close="onCloseModal" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import TsSelectClass from '@/components/SelectClass'
import * as FileDownload from 'downloadjs'
import { debounce, trim } from 'lodash'
import moment from 'moment'
import { mapState } from 'vuex'
import AudioComponent from './component/audio'
import StatusComponent from './component/change-status'
import StatusBySubProgram from './component/change-status-by-sub-program'
import Insurance from './component/insurance.vue'
import PreviewCard from './component/preview-card'
import DeleteComponent from './delete.vue'

export default {
  name: 'studentProfile',
  components: { TsSelectClass, Insurance },
  data() {
    return {
      showInsurance: false,
      waiting_fetch: false,
      visible: false,
      loading: false,
      exporting: false,
      visibleCard: false,
      checkedStudent: [],
      sub_programs: [],
      side: 'front',
      print_date: moment().format('DD-MM-YYYY'),
      branchs: [],
      boyPhoto: require('../../assets/student-default-boy.png'),
      girlPhoto: require('../../assets/student-default-girl.png'),
      studentInsurance: undefined
    }
  },
  computed: {
    ...mapState('studentProfile', ['resources', 'pagination', 'studentStatus']),
    search: {
      get() {
        return this.$store.state.studentProfile.search
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_SEARCH', newValue)
        this.$store.commit('studentProfile/RESET_CURRENT_PAGE')
      }
    },
    status_id: {
      get() {
        return this.$store.state.studentProfile.status_id
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_STATUS_ID', newValue)
      }
    },
    acps_id: {
      get() {
        return this.$store.state.studentProfile.acps_id
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_SUB_PROGRAM', newValue)
      }
    },
    is_print_card: {
      get() {
        return this.$store.state.studentProfile.is_print_card
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_IS_PRINT_CARD', newValue)
      }
    },
    id_card_activated: {
      get() {
        return this.$store.state.studentProfile.id_card_activated
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_ID_CARD_ACTIVATED', newValue)
      }
    },
    photo_exists: {
      get() {
        return this.$store.state.studentProfile.photo_exists
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_PHOTO_EXISTS', newValue)
      }
    },
    sound_exists: {
      get() {
        return this.$store.state.studentProfile.sound_exists
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_SOUND_EXISTS', newValue)
      }
    },
    linked_with_parent: {
      get() {
        return this.$store.state.studentProfile.linked_with_parent
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_LINKED_WITH_PARENT', newValue)
      }
    },
    main_program_count: {
      get() {
        return this.$store.state.studentProfile.main_program_count
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_MAIN_PROGRAM_COUNT', newValue)
      }
    },
    class_id: {
      get() {
        return this.$store.state.studentProfile.class_id
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_CLASS_ID', newValue)
      }
    },
    is_external() {
      return this.$store.state.authUser.is_external
    },
    branch_id: {
      get() {
        return this.$store.state.studentProfile.branch_id
      },
      set(newValue) {
        this.$store.commit('studentProfile/SET_BRANCH_ID', newValue)
      }
    },
    icolumns() {
      return [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.branch'
          ),
          slot: 'branch',
          minWidth: 120
        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.photo'
          ),
          slot: 'photo',
          minWidth: 80
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.cardNumber'),
          key: 'card_number',
          minWidth: 120
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.nameKh'),
          key: 'full_name_kh',
          minWidth: 120
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.nameEn'),
          key: 'full_name_en',
          minWidth: 120
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.otherForeignName'),
          key: 'full_name_foreign',
          className: 'ts-whitespace-no-wrap',
          width: 200
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.gender'),
          key: 'gender',
          minWidth: 80
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.dateOfBirth'),
          key: 'date_of_birth',
          width: 120
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.phoneNumber'),
          key: 'phone',
          width: 180
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.status'),
          slot: 'status',
          minWidth: 80
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.effectiveDate'),
          key: 'status_effective_date',
          minWidth: 120
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.statusBySubProgram'),
          slot: 'sub_program',
          minWidth: 200
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.className'),
          slot: 'classes',
          minWidth: 200
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.fatherName'),
          slot: 'father',
          minWidth: 150
        },
        {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.motherName'),
          slot: 'mother',
          minWidth: 150
        }, {
          title: this.$t('school.academic.operation.profile_mgt.studentProfile.cardCounter'),
          slot: 'counter',
          minWidth: 120,
          fixed: 'right',
          align: 'center',
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 200
        }
      ]
    }
  },
  mounted() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchResourceBeforeCreate()
    this.fetchData()
  },
  methods: {
    increaseCounter(record) {
      record._deleting = true
      this.$store
        .dispatch(
          'studentProfile/increasePrinterCardCounter',
          record.student_id
        )
        .then(response => {
          record.card_print_counter =
            parseInt(record.card_print_counter, 10) + 1
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    async fetchSubProgram() {
      this.loading = true
      this.$store
        .dispatch('studentProfile/getSubProgram')
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchResourceBeforeCreate() {
      this.$store
        .dispatch('studentProfile/getStudentStatus')
        .then(() => { })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'studentProfile/fetch',
          Object.assign(
            {
              branch_id: this.branch_id,
              page: this.pagination.currentPage
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    afterChangeStatus() {
      this.checkedStudent = []
      this.fetchData()
    },
    edit(record) {
      this.$store.commit('studentProfile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'student-profile-edit',
        params: { id: record.student_id }
      })
    },
    show(record) {
      this.$store.commit('studentProfile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'student-profile-show',
        params: { id: record.student_id }
      })
    },
    showDeleteForm(data) {
      this.$modal.show(
        DeleteComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '300px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    insurance(record) {
      this.studentInsurance = record
      this.showInsurance = true
    },
    showStatusForm(data) {
      this.$modal.show(
        StatusComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '25%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.afterChangeStatus
        }
      )
    },
    showStatusBySubProgramForm(data) {
      this.$modal.show(
        StatusBySubProgram,
        {
          data: data
        },
        {
          height: 'auto',
          width: '25%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    showAudioForm(data) {
      this.$modal.show(
        AudioComponent,
        {
          student: data
        },
        {
          height: 'auto',
          width: '500px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    checkItem(value) {
      this.checkedStudent = []
      if (!_.isEmpty(value)) {
        value.forEach(element => {
          this.checkedStudent.push(element.student_id)
        })
      }
    },
    previewCard(type) {
      this.visibleCard = false
      this.$modal.show(
        PreviewCard,
        {
          id_list: this.checkedStudent,
          side: this.side,
          print_date: this.print_date,
          type: type
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    card(record, side) {
      this.checkedStudent = []
      this.checkedStudent.push(record.student_id)
      this.side = side
      if (side == 'back') {
        this.visibleCard = true
      } else {
        this.previewCard()
        this.checkedStudent = []
      }
    },
    photoStudent(record) {
      if (record.photo) {
        return record.photo
      }

      return record.gender == 'Male' ? this.boyPhoto : this.girlPhoto
    },

    onError(record) {
      event
        ? (event.target.src =
          record.gender == 'Male' ? this.boyPhoto : this.girlPhoto)
        : ''
    },
    excel(record) {
      this.checkedStudent = []
      this.checkedStudent.push(record.student_id)
      this.exportExcelSelectedStudent()
      this.checkedStudent = []
    },
    exportExcelAllStudent() {
      this.checkedStudent = []
      this.exportExcelSelectedStudent()
    },
    exportExcelSelectedStudent() {
      this.exporting = true

      this.$store
        .dispatch('studentProfile/exportExcel', {
          student_id: this.checkedStudent,
          branch_id: this.branch_id,
          status_id: this.status_id,
          acps_id: this.acps_id,
          main_program_count: this.main_program_count,
          id_card_activated: this.id_card_activated,
          photo_exists: this.photo_exists,
          sound_exists: this.sound_exists,
          linked_with_parent: this.linked_with_parent,
          is_print_card: this.is_print_card,
          class_id: this.class_id
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => (this.exporting = false))
    },
    afterVisibleChange(val) {
      console.log('visible', val)
    },
    async showFilter() {
      this.visible = true
      this.waiting_fetch = true
      await Promise.all([
        this.fetchSubProgram(),
        this.fetchResourceBeforeCreate(),
        this.getBranch()
      ])
      this.waiting_fetch = false

    },
    onClose() {
      this.visible = false
    },
    clearFilter() {
      this.id_card_activated = null
      this.class_id = null
      this.photo_exists = null
      this.sound_exists = null
      this.linked_with_parent = null
      this.main_program_count = null
      this.is_print_card = null
      this.acps_id = []
    },
    onCloseModal() {
      this.studentInsurance = undefined
      this.showInsurance = false
    },
    onSelectCheck(selection, row) {
      if (!this.checkedStudent.includes(row.student_id)) {
        this.checkedStudent.push(row.student_id)
      }
      // this.setStudentListSelected(record)
    },
    onSelectUncheck(selection, row) {
      this.checkedStudent = this.checkedStudent.filter(
        key => key !== row.student_id
      )
      // this.setStudentListSelected(record)
    },
    onSelectAllCheck(record) {
      this.setStudentListSelected(record)
    },
    onSelectAllUncheck(record) {
      this.checkedStudent = []
      // this.setStudentListSelected(record)
    },
    handleSelectAll(status) {
      this.$refs.selection.selectAll(status)
    },
    handleSelectionChange(checkedStudent, selectedRows) {
      this.checkedStudent = checkedStudent
    },
    setStudentListSelected(records) {
      this.checkedStudent = []
      if (records.length > 0) {
        records.map(row => {
          this.checkedStudent.push(row.student_id)
        })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({
        search,
        branch_id: this.branch_id,
        status_id: this.status_id
      })
    }, 500),
    status_id: debounce(function (status_id) {
      this.fetchData({
        status_id,
        search: this.search,
        branch_id: this.branch_id
      })
    }, 500),
    id_card_activated: debounce(function (id_card_activated) {
      this.fetchData({
        id_card_activated,
        branch_id: this.branch_id
      })
    }, 500),
    photo_exists: debounce(function (photo_exists) {
      this.fetchData({
        photo_exists,
        branch_id: this.branch_id
      })
    }, 500),
    sound_exists: debounce(function (sound_exists) {
      this.fetchData({
        sound_exists,
        branch_id: this.branch_id
      })
    }, 500),
    linked_with_parent: debounce(function (linked_with_parent) {
      this.fetchData({
        linked_with_parent,
        branch_id: this.branch_id
      })
    }, 500),
    main_program_count: debounce(function (main_program_count) {
      this.fetchData({
        main_program_count,
        branch_id: this.branch_id
      })
    }, 500),
    class_id: debounce(function (class_id) {
      this.fetchData({
        class_id,
        branch_id: this.branch_id,
        filter: {
          student_in_class: class_id
        }
      })
    }, 500),
    acps_id: debounce(function (acps_id) {
      this.fetchData({
        acps_id,
        branch_id: this.branch_id
      })
    }, 500),
    is_print_card: debounce(function () {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
    is_external: debounce(function () {
      this.fetchData({ branch_id: this.branch_id })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'student-profile-create') {
      this.$store.commit('studentProfile/RESET_STATE')
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px;
  /* Remove scrollbar space */
  background: #ffff;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}

.table-status {
  display: table;
  border-collapse: collapse;
  border: none;
}

.table-status td {
  padding: 2px 4px;
  border-top: none !important;
  font-size: 10px;
}

table.table-status .icon {
  visibility: hidden;
}

table.table-status tr:hover .icon {
  visibility: visible;
}

.table>thead>tr>th,
.table>tbody>tr>th,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>tbody>tr>td,
.table>tfoot>tr>td {
  border-color: #e2e7eb;
  padding: 8px 10px;
}

.external-student {
  border-color: hsl(214, 100%, 59%);
  border-width: 2px;
}
</style>
